export const RESET = 'EM_DEMO/RESET';
export const FETCH_PRODUCTS_DATA = 'EM_DEMO/FETCH_PRODUCTS_DATA';
export const FETCH_PRODUCTS_LOADING = 'EM_DEMO/FETCH_PRODUCTS_LOADING';
export const FETCH_PRODUCTS_ERROR = 'EM_DEMO/FETCH_PRODUCTS_ERROR';
export const SET_PRODUCT_ID = 'EM_DEMO/SET_PRODUCT_ID';
export const SET_PRODUCT_TYPE = 'EM_DEMO/SET_PRODUCT_TYPE';
export const SET_CITY = 'EM_DEMO/SET_CITY';
export const SET_TIMESET = 'EM_DEMO/SET_TIMESET';
export const SET_POLLUTANT = 'EM_DEMO/SET_POLLUTANT';
export const SET_SECTOR = 'EM_DEMO/SET_SECTOR';
export const SET_YEAR = 'EM_DEMO/SET_YEAR';
export const SET_LANGUAGE = 'EM_DEMO/SET_LANGUAGE';
export const SET_MONTH = 'EM_DEMO/SET_MONTH';
export const SET_COMPARING_YEAR = 'EM_DEMO/SET_COMPARING_YEAR';
export const SET_COMPARING_MONTH = 'EM_DEMO/SET_COMPARING_MONTH';
export const SET_STATE = 'EM_DEMO/SET_STATE';
export const SET_BASEMAP = 'EM_DEMO/SET_BASEMAP';
export const SET_LABELS = 'EM_DEMO/SET_LABELS';
export const SET_VIEWPORT = 'EM_DEMO/SET_VIEWPORT';

export const defaultState = {
  // Raw data from the API
  products: {
    loading: false,
    error: false,
    data: []
  },
  // Actual state of the demo
  state: {
    productId: null,
    productType: null,
    pollutant: null,
    sector: null,
    year: null,
    month: null,
    language: 'english',
    comparingYear: null,
    comparingMonth: null,
    basemap: 'satellite',
    labels: 'light',
    viewport: null,
  }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case RESET:
      return defaultState;

    case FETCH_PRODUCTS_DATA:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, { data: action.payload })
      });

    case FETCH_PRODUCTS_LOADING:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, { loading: action.payload })
      });

    case FETCH_PRODUCTS_ERROR:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, { error: action.payload })
      });

    case SET_PRODUCT_ID:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { productId: action.payload })
      });

    case SET_PRODUCT_TYPE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { productType: action.payload }),
      });

    case SET_POLLUTANT:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { pollutant: action.payload })
      });

    case SET_SECTOR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { sector: action.payload })
      });

    case SET_CITY:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { city: action.payload })
      });
    
    case SET_TIMESET:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { timeset: action.payload })
      });

    case SET_YEAR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { year: action.payload })
      });

    case SET_MONTH:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { month: action.payload })
      });

    case SET_LANGUAGE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { language: action.payload })
      });

    case SET_COMPARING_YEAR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { comparingYear: action.payload })
      });

    case SET_COMPARING_MONTH:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { comparingMonth: action.payload })
      });

    case SET_STATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, action.payload)
      });

    case SET_BASEMAP:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { basemap: action.payload })
      });

    case SET_LABELS:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { labels: action.payload })
      });

    case SET_VIEWPORT:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { viewport: action.payload })
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/emissions-demo/reducer.js